import { TestingLayout } from "@/components/organisms/testing/TestingLayout";

export function TestingPage() {
  return (
    <div className="h-full overflow-hidden animate-fade-in">
      <TestingLayout />
    </div>
  );
}

export default TestingPage;
